import ufeApi from 'services/api/ufeApi';
import headerUtils from 'utils/Headers';
import userUtils from 'utils/User';

const { purchaseEventTimeStamp } = headerUtils;

// Attaches Google Pay via the credit-card endpoint; SDN converts the top-level
// `googlePay` wrapper to a GraphQL addPayment(googlePay) mutation. This is
// different from the other alternate payment methods
function initializeGooglePayCheckout(googlePay) {
    const url = '/api/checkout/orders/creditCard';

    const headers = {
        ...purchaseEventTimeStamp()
    };

    userUtils.insertSAZipCodeSACountryCodeHeaders(headers);

    return ufeApi
        .makeRequest(url, {
            method: 'POST',
            headers,
            body: JSON.stringify({ googlePay })
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

export default initializeGooglePayCheckout;
